export let ImageKey;

(function (ImageKey) {
  ImageKey["Flywheel"] = "FLYWHEEL";
  ImageKey["Rever"] = "REVER";
  ImageKey["SalesLeaderCalendar"] = "SALES_LEADER_CALENDAR";
  ImageKey["SalesMeetingsCalendar"] = "SALES_MEETINGS_CALENDAR";
  ImageKey["SalesMeetingsConfirmation"] = "SALES_MEETINGS_CONFIRMATION";
  ImageKey["TimeslotCalendar"] = "TIMESLOT_CALENDAR";
  ImageKey["Wordpress"] = "WORDPRESS";
})(ImageKey || (ImageKey = {}));